import styled, { css } from 'styled-components';

export const WrapperLoadingError = styled.div`
  ${() => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 85vh;
    flex-direction: column;
    padding: 24px;
  `}
`;

export const Message = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    color: ${theme.v2.colors.neutral.lowLight};
    font-weight: ${theme.v2.font.weights.medium};
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;
